import * as React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'

import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { RootState } from '../store/rootReducer'
import { User, hasAnyPermission } from '../lib/interfaces/User.interface'

export interface ChangeableBadgeProps {
  user: User
  style?: any
  value?: string
  options: any[]
  badgeText: string
  className?: string
  enableChange?: boolean
  containerMinWidth?: any
  changePermissions?: string[]
  onChange?: (option: any) => void
  getOptionLabel: (option: any) => string
  getOptionValue: (option: any) => string
}

interface ChangeableBadgeState {
  isMenuOpen: boolean
}

class ChangeableBadge extends React.PureComponent<ChangeableBadgeProps, ChangeableBadgeState> {
  state: ChangeableBadgeState = {
    isMenuOpen: false
  }

  get hasChangePermission() {
    const { user, enableChange, changePermissions } = this.props

    if (!enableChange) {
      return false
    }

    return hasAnyPermission(user, changePermissions || [])
  }

  get selectStyles() {
    const { containerMinWidth } = this.props
    
    return {
      container: provided => ({
        ...provided,
        width: '100%',
        height: '100%',
        cursor: 'pointer'
      }),
      menuPortal: provided => ({
        ...provided,
        zIndex: 99999,
        top: provided.top - 20,
        minWidth: containerMinWidth || '45px'
      }),
      control: provided => ({
        ...provided,
        opacity: 0,
        width: '100%',
        height: '100%',
        cursor: 'pointer'
      }),
      valueContainer: provided => ({
        ...provided,
        padding: '0 3px',
        textAlign: 'center'
      }),
      singleValue: provided => ({
        ...provided,
        width: '100%',
        fontWeight: 'bold'
      }),
      option: (provided, state) => {
        return {
        ...provided,
        fontSize: '12px',
        padding: '3px 5px',
        color: state.isFocused || state.isSelected ? 'white' : 'black',
        backgroundColor:
          state.isFocused
            ? '#494949'
            : state.isSelected
              ? '#595959'
              : 'transparent',

        ':active': {
          ...provided[':active'],
          backgroundColor: state.isSelected
            ? '#595959'
            : '#494949'
        }
      }}
    }
  }

  render() {
    const { isMenuOpen } = this.state
    const { style, value, options, onChange, className, badgeText, getOptionLabel, getOptionValue } = this.props

    const hasChangePermission = this.hasChangePermission

    return (
      <span
        style={style}
        onClick={() => hasChangePermission && this.setState({ isMenuOpen: true })}
        className={classnames('changeablebadge', { 'changeablebadge--open': isMenuOpen , 'cursor-pointer': hasChangePermission }, className)}
      >
        <div className="position-relative w-100 h-100">
          {badgeText}

          {hasChangePermission &&
            <React.Fragment>
              <FontAwesomeIcon icon={['fas', 'chevron-down']} />

              <div className="optionselect-wrapper">
                <Select
                  isSearchable
                  value={value}
                  options={options}
                  onChange={onChange}
                  menuIsOpen={isMenuOpen}
                  styles={this.selectStyles}
                  getOptionLabel={getOptionLabel}
                  getOptionValue={getOptionValue}
                  menuPortalTarget={document.querySelector('body')}
                  onMenuOpen={() => this.setState({ isMenuOpen: true })}
                  onMenuClose={() => this.setState({ isMenuOpen: false })}
                />
              </div>
            </React.Fragment>
          }
        </div>
      </span>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user
})

export default connect(mapStateToProps)(ChangeableBadge)



// WEBPACK FOOTER //
// ./src/common/ChangeableBadge.component.tsx